// GoogleAnalytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = ({ trackingId }) => {
  const location = useLocation();

  useEffect(() => {
    // Trigger the page view event whenever the path changes
    if (window.gtag) {
      window.gtag('config', trackingId, {
        page_path: location.pathname + location.search,
      });
      console.log(`Tracking pageview for ${location.pathname}${location.search}`);
    }
  }, [location, trackingId]);

  return null; // This component doesn't render anything visible
};

export default GoogleAnalytics;
